export const baseUrl = "https://api.gambitchess.ir";
// export const baseUrl = "http://192.168.10.25:8000";
